import { render, staticRenderFns } from "./sending_mail.vue?vue&type=template&id=4067e086"
import script from "./sending_mail.vue?vue&type=script&lang=js"
export * from "./sending_mail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports